export type OrgAccessFilter = 'access' | 'none' | 'all';

export function matchesOrgAccessFilter(
  studioAccess: boolean,
  filter: OrgAccessFilter,
): boolean {
  if (filter === 'access') return studioAccess;
  if (filter === 'none') return !studioAccess;
  return true;
}
